export default __webpack_public_path__ + "static/media/homeopathy.f640f57a.svg";